import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-scroll";
import { colors } from "../constants/colors";

const TopArrow = () => (
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 4.5 5.5 11l1.4 1.4L11 8.7V19h2V8.7l4.1 3.7 1.4-1.4L12 4.5Z"
      fill="currentColor"
    />
  </svg>
);

const BackButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Animation variants
  const buttonVariants = {
    hidden: {
      opacity: 0,
      scale: 0.5,
      rotate: -180,
      y: 100,
    },
    visible: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
        duration: 0.6,
      },
    },
    hover: {
      scale: 1.1,
      rotate: 360,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 10,
        duration: 0.3,
      },
    },
    tap: {
      scale: 0.9,
      transition: {
        type: "spring",
        stiffness: 600,
        damping: 15,
        duration: 0.1,
      },
    },
  };

  const iconVariants = {
    hidden: { y: 10, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        delay: 0.2,
        duration: 0.4,
      },
    },
    hover: {
      y: -3,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 15,
        repeat: Infinity,
        repeatType: "reverse",
        duration: 0.8,
      },
    },
  };

  // Enhanced styles
  const backButtonStyle = {
    borderRadius: "50%",
    padding: "12px",
    cursor: "pointer",
    height: "50px",
    width: "50px",
    position: "fixed",
    bottom: "30px",
    right: "30px",
    zIndex: 9999,
    background: isHovered
      ? `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})`
      : `linear-gradient(135deg, ${colors.primary}, ${colors.primary})`,
    boxShadow: isHovered
      ? "0 8px 25px rgba(73, 177, 82, 0.4), 0 0 20px rgba(73, 177, 82, 0.2)"
      : "0 4px 15px rgba(73, 177, 82, 0.3)",
    border: "2px solid rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(10px)",
  };

  const iconStyle = {
    height: "24px",
    width: "24px",
    color: "#ffffff",
    filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          variants={buttonVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          whileHover="hover"
          whileTap="tap"
          onHoverStart={() => setIsHovered(true)}
          onHoverEnd={() => setIsHovered(false)}
          style={backButtonStyle}
        >
          <Link
            to="home"
            spy={true}
            smooth={true}
            duration={220}
            delay={0}
            offset={-100}
          >
            <motion.div
              variants={iconVariants}
              initial="hidden"
              animate={isHovered ? "hover" : "visible"}
              style={iconStyle}
            >
              <TopArrow />
            </motion.div>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BackButton;
